window.Products.Bag = {

};
window.Products.Bag.Bag = function() {
	
};
window.Products.Bag.Bag.inherits(window.Products.Product);

window.Products.Bag.Bag.dpi = 150;